import "./CombinePdts.css";

    import { useEffect, useState, useRef } from "react";
    import axios_with_token, { delTblRcds } from "../../axios_with_token";

import { getJsonPath, getBkendUrl } from "../../consts";
import BSPagination from "../../input_types/BSPaginition/BSPaginition";

import Tbl from "../../input_types/Tbl/Tbl";
// import ModalRcdEdit from "../../input_types/ModalRcdEdit/ModalRcdEdit";

const jsonPath = getJsonPath();
const bkendUrl = getBkendUrl();

const PCToDZ = pcVal=>Math.round(pcVal / 12.0 * 100.0) / 100.0;

export default function CombinePdts(props){
    return <div>
        cmbine pdt
    </div>;
}